import * as React from 'react';
import { Layout } from '@/components/atoms';

export type ServiceTemplateProps = {
  children: React.ReactNode;
  className?: string;
};

const ServiceTemplate = ({ children, className }: ServiceTemplateProps) => {
  const classNames = ['service', className];
  return <Layout className={classNames.join(' ')}>{children}</Layout>;
};

export default ServiceTemplate;
